import { useEffect, useState } from "react";
import { LegalDocLink } from "./LegalDocLink";
import { LEGAL_PUBLIC_ENABLED } from "../../constants/legalPaths";
import {
  hasCookieDecision,
  setCookieConsent,
} from "../../utils/cookieConsent";
import { ensureYandexMetrikaLoaded } from "../../analytics/loadYandexMetrika";
import { yandexMetrikaHit } from "../../analytics/yandexMetrika";
import s from "./legalGates.module.css";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!LEGAL_PUBLIC_ENABLED) return;
    if (hasCookieDecision()) {
      ensureYandexMetrikaLoaded().then((ok) => {
        if (ok) yandexMetrikaHit();
      });
      return;
    }
    setVisible(true);
  }, []);

  if (!LEGAL_PUBLIC_ENABLED || !visible) return null;

  const accept = () => {
    setCookieConsent({ analytics: true });
    setVisible(false);
    ensureYandexMetrikaLoaded().then((ok) => {
      if (ok) yandexMetrikaHit();
    });
  };

  return (
    <div className={s.cookieBar} role="dialog" aria-label="Cookies">
      <p>
        Мы используем cookies для работы сервиса. Подробнее в{" "}
        <LegalDocLink doc="cookies">политике cookies</LegalDocLink>.
      </p>
      <div className={s.cookieActions}>
        <button
          type="button"
          className={`${s.cookieBtn} ${s.cookieBtnPrimary}`}
          onClick={accept}
        >
          Принять
        </button>
      </div>
    </div>
  );
}
